// @ts-ignore
import Glide from '@glidejs/glide/dist/glide.esm';
// @ts-ignore
import { jarallax, jarallaxVideo } from "jarallax/dist/jarallax.esm";

export class HeroSliderClass {
    private glide: any = null;
    private readonly slider: Element;
    private bullets: NodeListOf<HTMLElement>;
    private slides: NodeListOf<HTMLElement>;
    private slidesCount: number = 0;

    constructor(slider: Element) {
        this.slider = slider;
        this.bullets = this.slider.querySelectorAll('.o-hero__buttons-bullet');
        this.slides = this.slider.querySelectorAll('.glide__slide');
        this.slidesCount = this.slides.length;

        if (this.slider) {
            this.init();
        }
    }

    init() {
        let _this = this;
        // init and configure glide.js
        this.glide = new Glide(this.slider, {
            type: 'slider',
            gap: 0,
            autoplay: false,
            perView: 1,
            classes: {
                direction: {
                    ltr: 'dir-ltr',
                    rtl: 'dir-rtl'
                },
                slider: 'is-slider',
                carousel: 'is-carousel',
                swipeable: 'is-swipeable',
                dragging: 'is-dragging',
                cloneSlide: 'is-clone',
                activeNav: 'is-active',
                activeSlide: 'is-active',
                controls: 'c-slider__arrows',
                backArrow: 'c-slider__arrow-prev',
                nextArrow: 'c-slider__arrow-next',
                disabledArrow: 'is-disabled'
            },
        });

        this.glide.on('mount.after', function () {
            _this.initVideoControls(_this.slider);
            jarallax(_this.slider, {
                speed: 1.5,
            });
            jarallaxVideo(_this.slider, {
                speed: 1.5,
            });
        });

        this.glide.on('run', () => {
            //requestAnimationFrame(() => this.changeActiveBullet(this.glide.index, this.slider.querySelector('.glide__bullets')));
        });

        this.glide.mount();
        // Disable Slider if only one slide available
        if(_this.slidesCount <= 1){
            this.glide.disable();
        }
    }

    private initVideoControls(slider: Element) {

        // Fake Autoplay, so videos in hidden slides do not start
        var $videos = slider.querySelectorAll<HTMLVideoElement>('[data-slider-video]');

        // Play/Pause Button
        if ($videos.length > 0) {
            $videos.forEach((video) => {
                let videoControllId = video.id,
                    videoController = document.querySelector('[data-slider-videocontrols="' + videoControllId + '"]'),
                    videoControllPlay = videoController.querySelector('[data-slider-videocontrols-play]'),
                    videoControllMute = videoController.querySelector('[data-slider-videocontrols-mute]'),
                    videoControllFullscreen = videoController.querySelector('[data-slider-videocontrols-fullscreen]');

                if (videoControllPlay) {
                    videoControllPlay.addEventListener('click', function (event) {
                        if (video.paused) {
                            video.play();
                            videoControllPlay.classList.remove('u-icon-before--play');
                            videoControllPlay.classList.add('u-icon-before--pause');
                        } else {
                            video.pause();
                            videoControllPlay.classList.add('u-icon-before--play');
                            videoControllPlay.classList.remove('u-icon-before--pause');
                        }
                    }, false);
                }

                // Mute/Unmute Button
                if (videoControllMute) {
                    videoControllMute.addEventListener('click', function (event) {
                        if (video.muted) {
                            videoControllMute.classList.remove('u-icon-before--volume-low');
                            videoControllMute.classList.add('u-icon-before--volume-high');
                        } else {
                            videoControllMute.classList.add('u-icon-before--volume-low');
                            videoControllMute.classList.remove('u-icon-before--volume-high');
                        }
                        video.muted = !video.muted;
                    }, false);
                }

                // Fullscreen Button
                if (videoControllFullscreen) {
                    videoControllFullscreen.addEventListener('click', function (event) {
                        if (video.requestFullscreen) {
                            video.requestFullscreen();
                        }
                    }, false);
                }
            });
        }
    }

}

document.querySelectorAll('[data-slider]').forEach((item) => {
    new HeroSliderClass(item);
});